// TL simge ikonu — lucide'de ₺ olmadığı için $ (DollarSign) yerine kullanılır.
// lucide ikonlarıyla aynı arayüz (size prop) → drop-in. Renk currentColor'dan gelir.
const TlIcon = ({ size = 20, className, style, ...rest }) => (
    <span
        className={className}
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: size,
            height: size,
            fontSize: Math.round(size * 0.95),
            fontWeight: 700,
            lineHeight: 1,
            ...style,
        }}
        aria-hidden="true"
        {...rest}
    >
        ₺
    </span>
);

export default TlIcon;
